"use client"

import { useEffect } from 'react'
import {
  ensureChatbotEmbed,
  type ChatbotEmbedLocale,
} from '@/lib/atirame-chatbot-embed'

type LandingChatbotEmbedProps = {
  locale: ChatbotEmbedLocale
}

/**
 * Loads the Atirame chatbot on international landing pages with an explicit locale.
 * Root layout uses lang="fa", so data-language must be set or the widget falls back to Persian.
 */
export function LandingChatbotEmbed({ locale }: LandingChatbotEmbedProps) {
  useEffect(() => {
    let cancelled = false

    void ensureChatbotEmbed(locale).catch((error) => {
      if (!cancelled) {
        console.error('[LandingChatbotEmbed] Failed to load chatbot widget:', error)
      }
    })

    return () => {
      cancelled = true
    }
  }, [locale])

  return null
}
